import { useEffect, useState } from "react";
import { useAuth } from "./useAuth";
import { getCurrentCustomer } from "@/Calls/callCustomerAuth";

export function useCustomerSession() {
    const { user, setUser } = useAuth();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let active = true;

        async function load() {
            try {
                const customer = await getCurrentCustomer();
                if (!active) return;

                if (customer) {
                    setUser({
                        id: customer.customer_id,
                        role: "CUSTOMER",
                        dealerId: String(customer.customer_dealer_id),
                        page: "/customer/dashboard",
                    });
                } else {
                    setUser(null);
                }
            } catch (err) {
                if (err instanceof Error) setError(err.message);
                else setError("Failed to load session");
            } finally {
                if (active) setLoading(false);
            }
        }

        load();
        return () => { active = false; };
    }, [setUser]);

    return { user, loading, error };
}
